import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PwaService {
    private deferredPrompt: any;
    private showInstallPromotion = new BehaviorSubject<boolean>(false);
    public showInstallPromotion$ = this.showInstallPromotion.asObservable();

    constructor() {
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            this.deferredPrompt = e;
            this.showInstallPromotion.next(true);
        });

        window.addEventListener('appinstalled', () => {
            this.deferredPrompt = null;
            this.showInstallPromotion.next(false);
        });
    }

    public async installPwa() {
        if (!this.deferredPrompt) {
            return;
        }
        this.deferredPrompt.prompt();
        const { outcome } = await this.deferredPrompt.userChoice;
        this.deferredPrompt = null;
        this.showInstallPromotion.next(false);
    }
}
